import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresEditarAltasConfirmarComponent {
  constructor (FanProyectoColaboradoresAltasService) {
    this.FanProyectoColaboradoresAltasService = FanProyectoColaboradoresAltasService
    this.onClose = null
    this.idProyecto = null
    this.data = ''
    this.actualizando = false
    this.completado = false
    this.total = 0
    this.contador = 0
    this.fecha = null
    this.notas = ''
    this.error = null
    this.resultados = null
    this.completados = []
    this.iteracion = 0
  }

  iniciar () {
    if (this.actualizando) return

    this.actualizando = true

    this.resultados = [...this.data]
    this.resultados.forEach((item) => {
      item.fecha = this.fecha
      item.notas = this.notas
    })

    this.total = this.resultados.length
    this.progreso = (this.iteracion / this.total) || 0
    this.siguiente()
  }

  siguiente () {
    if (!this.resultados.length) {
      this.finalizar()
      return
    }
    let colaborador = this.resultados.shift()
    this.actualizar(colaborador)
  }

  finalizar () {
    this.actualizando = false
    this.completado = !this.error
  }

  actualizar (colaborador) {
    this.FanProyectoColaboradoresAltasService.put(this.idProyecto, colaborador)
      .then((response) => {
        colaborador.completado = true
        colaborador.actualizado = response.data.actualizado
        colaborador.error = response.data.error

      })
      .catch((error) => (this.error = error.data))
      .finally(() => {
        this.iteracion++
        this.progreso = (this.iteracion / this.total) || 0
        let indic = this.data.indexOf(this.data.find((item) => item.indice === colaborador.indice))
        this.data[indic] = colaborador
        this.contador++;
        if (!colaborador.error)
          this.completados.push(colaborador)
        this.siguiente()
      })
  }

  cerrar (termino) {
    this.onClose({$event: {detail: (termino) ? this.data : false}})
  }
}

module.component('fanProyectoColaboradoresEditarAltasConfirmar', {
  controller: FanProyectoColaboradoresEditarAltasConfirmarComponent,
  template,
  bindings: {
    idProyecto: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/editar/altas/confirmar/component.js